import React, {useState} from "react";
import styles from "./ActivationCode.module.scss";
import Btn from "../Button/Button";
import TextField from "@material-ui/core/TextField";
import { errorCode } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";


/**
 * ActivationCode component for users who are part of an existing study to enter their activation code.
 * The component handles user input, shows validation feedback, and triggers registration using the provided code.
 *
 * @component
 *
 * @param {Object} props - Component props
 * @param {Function} props.onClickRegisterWithCode - Callback invoked when the user clicks the "Register with code" button.
 *        Receives the entered code and a setter function to update the button label/state.
 *
 * @returns {JSX.Element} The rendered activation code input form
 */
const ActivationCode = ({onClickRegisterWithCode}) => {
    
    const [code, setCode] = useState("");
    const dispatch = useDispatch();
    const state = useSelector((state) => state.general);
    const [registerButtonEvent, setRegisterButtonEvent] = useState("Register with code");

    return (
        <div className={styles.activationCodeFormStyle}>
            <p className={styles.activationCodeParagraph}>
                If you are part of an existing study, please enter the activation code provided by your coordinator
            </p>
            <p className={styles.activationCodeTextInputTitle} >
                Activation code
            </p>
            <TextField
                value={code}
                onChange={(e) => {
                    setCode(e.target.value);
                    setRegisterButtonEvent("Register with code");
                    dispatch(errorCode(false));
                }}
                fullWidth
                placeholder="e.g. 7YKUJ892"
                variant="outlined"
                InputProps={{
                    classes: {
                        root: styles.activationCodetextFieldRoot,
                        input: styles.activationCodetextFieldInput,
                    },
                }}
                InputLabelProps={{ shrink: false }}
            />
            {state.errorCode && (
                <a className={styles.errorMessage}>
                    Invalid activation code!
                </a>
            )}

            <div className={styles.activationCodeButtonContainer}>
                <Btn
                    stylebutton={"primary"}
                    event={registerButtonEvent}
                    onClick={() => onClickRegisterWithCode(code, setRegisterButtonEvent)}
                />
            </div>
        </div>
    );
};

export default ActivationCode;